"use strict";

var e, s;

function t(t) {
  var O = function O(e, s) {
    return {
      type: e,
      os: s
    };
  },
      n = t.toLowerCase();

  switch (!0) {
    case n.includes("ipad"):
      return O(e.TABLET, s.IOS);

    case n.includes("iphone"):
      return O(e.MOBILE, s.IOS);

    case n.includes("android"):
      return n.includes("mobile") || n.includes("phone") ? O(e.MOBILE, s.ANDROID) : O(e.TABLET, s.ANDROID);

    case n.includes("wm7"):
    case n.includes("wm8"):
      return O(e.MOBILE, s.WINDOWS_PHONE);

    default:
      return O(e.DESKTOP, s.UNKNOWN);
  }
}

Object.defineProperty(exports, "__esModule", {
  value: !0
}), function (e) {
  e[e.MOBILE = 0] = "MOBILE", e[e.TABLET = 1] = "TABLET", e[e.DESKTOP = 2] = "DESKTOP";
}(e || (e = {})), function (e) {
  e[e.IOS = 0] = "IOS", e[e.ANDROID = 1] = "ANDROID", e[e.WINDOWS_PHONE = 2] = "WINDOWS_PHONE", e[e.UNKNOWN = 3] = "UNKNOWN";
}(s || (s = {}));
var O = t("undefined" != typeof navigator ? navigator.userAgent : ""),
    n = O.type === e.MOBILE || O.type === e.TABLET,
    r = O.type === e.MOBILE,
    i = O.type === e.TABLET,
    o = O.type === e.DESKTOP,
    u = O.os === s.IOS,
    I = O.os === s.WINDOWS_PHONE;
exports.isAndroid = O.os === s.ANDROID, exports.isBrowser = o, exports.isIOS = u, exports.isMobile = n, exports.isMobileOnly = r, exports.isTablet = i, exports.isWinPhone = I;